import sdk from '@psp-aggregator/sdk';

export const useDeal = (dealId: string, enabled = true) =>
  sdk.queries.useGetDeal(dealId, { enabled: enabled && dealId.length > 0 });
